import { KYMW1704Model } from '../kymw1704.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';


/**
 * 画面再表示時の情報取得するサービス
 *
 * @export ReplaceImageFileService
 * @class ReplaceImageFileService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class ReplaceImageFileService extends PlessJsonResponderSub<any> {

  public readonly KEY_IMAGE_PREVIEW_EXT: string = 'ImagePreviewExt';	// 画像プレビュー画像拡張子(png)
  public readonly KEY_IMAGE_FILE_EXT: string = 'ImageFileExt';		// 画像ファイルの拡張子(eps)
  public readonly KEY_IMAGE_CWS_EXT: string		= 'ImageCWSExt';		// CWS画像ファイル拡張子(jpg)
  public readonly KEY_IMAGE_FILE_SMALL: string		= 'ImageFileSmall';		// 画像ファイル名(小)
  public readonly KEY_IMAGE_FILE_MIDDLE: string	= 'ImageFileMiddle';	// 画像ファイル名(中)
  public readonly KEY_IMAGE_FILE_LARGE: string		= 'ImageFileLarge';		// 画像ファイル名(大)

  private vo: any;

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1704Model}
   * @memberof ReplaceImageFileService
   */
  private model: KYMW1704Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof ReplaceImageFileService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof ReplaceImageFileService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        TempPNGFileName: this.vo.tempPNGFileName,
        TempEPSFileName: this.vo.tempEPSFileName,
        TempJPGSFileName: this.vo.tempJPGSFileName,
        TempJPGMFileName: this.vo.tempJPGMFileName,
        TempJPGLFileName: this.vo.tempJPGLFileName,
        imageBelongId: this.vo.imageBelongId,
        pCode: this.vo.pCode,
        imageType: this.vo.imageType,
        jpgUpdateFlg: this.vo.jpgUpdateFlg
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof ReplaceImageFileService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1704Model> model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW17ReplaceImageFile', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof ReplaceImageFileService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
